import '../i18n';
/* -- cone add component import 初始化 start，勿删 --*/
import CnFilterAlcPrototypeView from './cn-filter-alc/prototypeView';
import CnTableAlcPrototypeView from './cn-table-alc/prototypeView';
import CnPageAlcPrototypeView from './cn-page-alc/prototypeView';
import CnTabAlcPrototypeView from './cn-tab-alc/prototypeView';
import CnFormAlcPrototypeView from './cn-form-alc/prototypeView';
import CnDialogAlcPrototypeView from './cn-dialog-alc/prototypeView';
import CnFormDialogAlcPrototypeView from './cn-form-dialog-alc/prototypeView';
import CnMessageAlcPrototypeView from './cn-message-alc/prototypeView';
import PageAlcPrototypeView from './page/prototypeView';
import CnCardAlcPrototypeView from './cn-card-alc/prototypeView';
import CnCardSubCardAlcPrototypeView from './cn-card-sub-card-alc/prototypeView';
import CnStepAlcPrototypeView from './cn-step-alc/prototypeView';
import CnLeftTreeAlcPrototypeView from './cn-left-tree-alc/prototypeView';
import CnResultAlcPrototypeView from './cn-result-alc/prototypeView';
import CnListAlcPrototypeView from './cn-list-alc/prototypeView';
import CnEntryPointsAlcPrototypeView from './cn-entry-points-alc/prototypeView';
import CnSliderAlcPrototypeView from './cn-slider-alc/prototypeView';
import CnDetailInfoAlcPrototypeView from './cn-detail-info-alc/prototypeView';
// import CnFormatPrototypeView from './cn-format-alc/prototypeView';
// import CnStatisticCardProPrototypeView from './cn-statistic-card-pro-alc/prototypeView';
/* -- cone add component import 初始化 end，勿删 --*/
import CnLowcodePagePrototypeView from '@alife/cn-lowcode-page/es/lowcode/prototypeView';
import CnLayoutBundle from '@cainiaofe/cn-ui-layout/es/lowcode/prototypeView';
import './prototypeView.scss';
import { getCommonOpenUtil } from '@/common/util';
if (!window.cnLowCodeUtils) {
    window.cnLowCodeUtils = {
        ...getCommonOpenUtil(),
    };
}
// 通过arr控制输出的顺序
const bundle = [
    /* -- cone add component bundle 初始化 start，勿删 --*/
    CnFilterAlcPrototypeView,
    CnTableAlcPrototypeView,
    CnFormAlcPrototypeView,
    CnFormDialogAlcPrototypeView,
    CnPageAlcPrototypeView,
    CnTabAlcPrototypeView,
    CnDialogAlcPrototypeView,
    CnMessageAlcPrototypeView,
    PageAlcPrototypeView,
    CnCardAlcPrototypeView,
    CnCardSubCardAlcPrototypeView,
    CnStepAlcPrototypeView,
    CnLeftTreeAlcPrototypeView,
    CnResultAlcPrototypeView,
    CnListAlcPrototypeView,
    CnEntryPointsAlcPrototypeView,
    CnSliderAlcPrototypeView,
    CnDetailInfoAlcPrototypeView,
    // CnFormatPrototypeView,
    // CnStatisticCardProPrototypeView,
    /* -- cone add component bundle 初始化 end，勿删 --*/
    CnLowcodePagePrototypeView,
    ...CnLayoutBundle,
];
export default bundle;
